// Mirrors xpens-engine `tax_profile_DAO.get_default_tax_profile` (the
// is_default-flagged row), with the same `"N_IN"` literal fallback the
// existing inline call sites use when the tenant has no is_default row.
export const resolveDefaultTaxCode = (tax_profile) => {
  const profiles = Array.isArray(tax_profile) ? tax_profile : [];
  return profiles.find((p) => p?.is_default === true && p?.code)?.code ?? "N_IN";
};

// Mirrors xpens-engine `tax_profile_DAO.get_taxed_code_from_candidates`:
//   - return T_IN or BCGSTPSTIN when present (canonical taxed codes),
//   - otherwise pick the profile with the most components, tie-breaking
//     on the highest summed rate (engine's `effective_rate`),
//   - fall back to the literal "T_IN" when the tenant has no taxed
//     profile configured (matches the legacy hardcoded fallback).
const CANONICAL_TAXED_CODES = ["T_IN", "BCGSTPSTIN"];

export const resolveTaxedCode = (tax_profile) => {
  const profiles = Array.isArray(tax_profile) ? tax_profile : [];
  const canonical = profiles.find((p) => CANONICAL_TAXED_CODES.includes(p?.code));
  if (canonical) return canonical.code;

  let bestCode = null;
  let bestComponents = -1;
  let bestRate = -1;
  for (const p of profiles) {
    if (!p?.code) continue;
    const rates = p.adjusted_rates || p.list_rates || [];
    if (!rates.some((r) => Number(r) > 0)) continue;
    const components = rates.length;
    const effectiveRate = rates.reduce((sum, r) => sum + Number(r || 0), 0);
    if (components > bestComponents || (components === bestComponents && effectiveRate > bestRate)) {
      bestCode = p.code;
      bestComponents = components;
      bestRate = effectiveRate;
    }
  }
  return bestCode ?? "T_IN";
};
